import React from 'react';
import { Panel, Label, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';
import ui from '../../../common/services/ui';
import moment from 'moment';

const daysOwed = owedSince => moment().startOf('day').diff(moment(owedSince).startOf('day'), 'days');

const List = ({ t, canSettle, onSettle, ...rest }) => {
	const categoryPath = (paymentCategory) => {
		switch (paymentCategory) {
			case 'Lesson': return 'paymentHistory';
			case 'Workshop': return 'workshopPayments';
			case 'Consultation': return 'individualConsultations';
		}
	}
	
	const columns = [
		{
			header: t('CancellationCreditNote_CancellationDate'),
			accessor: 'cancellationDate',
			sortable: true,
			cell: (cancellationDate) => (ui.formatDateTime(cancellationDate))
		},
		{
			header: t('CancellationCreditNote_CancellationReason'),
			accessor: 'cancellationReason',
			cell: (cancellationReason, row) => t(`CancellationReasonType_${cancellationReason}`) + (cancellationReason == 'Other' && row.otherCancellationReason ? ": " + row.otherCancellationReason : ""),
			sortable: true
		},
		{
			header: t('CancellationCreditNote_Quantity'),
			accessor: 'quantity',
			sortable: true
		},
		{
			header: t('CancellationCreditNote_Amount'),
			accessor: 'amount',
			cell: (amount) => ui.formatAmount(amount),
			sortable: true
		},
		{
			header: t('CancellationCreditNote_Settlement'),
			accessor: 'settlementStatus',
			cell: (settlementStatus, row) => settlementStatus ? <span className='cell-stack'>
				<Label bsStyle={settlementStatus === 'Owed' ? 'warning' : 'success'}>{t(`RefundSettlementStatus_${settlementStatus}`)}</Label>
				{/* subscription refunds must be paid back within 14 days */}
				{settlementStatus === 'Owed' && row.owedSince && <div className={row.hasSettlementDeadline && daysOwed(row.owedSince) >= 10 ? 'text-danger' : 'text-muted'}>{t('CancellationCreditNote_OwedForDays', { count: daysOwed(row.owedSince) })}</div>}
				{settlementStatus === 'Settled' && <div className='text-muted'>
					{ui.formatDate(row.settledAt)}{row.settlementReference && ` · ${t('CancellationCreditNote_SettlementReferenceShort')} ${row.settlementReference}`}
				</div>}
				{settlementStatus === 'Owed' && canSettle && <div><Button bsSize='xsmall' onClick={() => onSettle(row)}>{t('CancellationCreditNote_MarkAsSettled')}</Button></div>}
			</span> : null,
			sortable: false
		},
		{
			header: t('CancellationCreditNote_Payment'),
			accessor: 'rootPaymentId',
			cell: (rootPaymentId, row) => (<Link to={
				`/${categoryPath(row.paymentCategory)}/${rootPaymentId}`} > {rootPaymentId}</Link>),
			sortable: false
		},
		{
			header: t('CancellationCreditNote_PaymentCategory'),
			accessor: 'paymentCategory',
			cell: (paymentCategory) => <span>{t(`PaymentCategory_${paymentCategory}`)}</span>,
			sortable: false
		},
		{
			header: t('CancellationCreditNote_Center'),
			accessor: 'center.name',
			sortable: false
		},
		{
			header: t('CancellationCreditNote_Parent'),
			accessor: 'parent',
			cell: (child, row) => (<Link to={`/parents/${row.parent.id}`} > {row.parent.name}</Link>),
			sortable: false
		},
		{
			header: t('CancellationCreditNote_Child'),
			accessor: 'child',
			cell: (child, row) => (<Link to={`/parents/${row.parent.id}/children/${row.child.id}`} > {child.name}</Link>),
			sortable: false
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);